export const TEXT_FIELD_BACKGROUND_COLOR = 'rgba(232, 240, 242, 0.5)';

export const TEXT_FIELD_BORDER = '1px solid #F5F8FA';
